import React from "react";
import { Navigate } from "react-router-dom";

const UserRoute = ({ user, children }) => {
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== "user") return <Navigate to="/" replace />;

  return children;
};

export default UserRoute;
